module.exports = __webpack_public_path__ + "static/img/lotte-food.4307452.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lotte-food.jpg
// module id = MH1q
// module chunks = 0